import isWindowDefined from '../../isWindowDefined';
import { ScreenSize } from '../constants';
import { screenSizeMap } from '../constants';

/**
 * A helper function used by order confirm page and it's components
 * screen logic does not get out of sync. Use innerWidth to determine screen
 * because hooks are not available to use in the withPageView HOC.
 * @param screenSize
 * @returns boolean
 */
var getIsScreenSizePhone = function getIsScreenSizePhone(screenSize) {
  if (screenSize === ScreenSize.PHONE) {
    return true;
  }
  if (isWindowDefined) {
    return window.innerWidth < screenSizeMap.TABLET;
  }
  return false;
};
export default getIsScreenSizePhone;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/utils/dist/esm/screen/utils/getIsScreenSizePhone.js
// module id = 2856
// module chunks = 11